import { type IngredientKind } from '@sg/graphql-schema';

import {
  type ExtendedModifierGroup,
  type ProductModification,
  type ProductModifierGroup,
} from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function extendModifierGroup(
  modifierGroup: ProductModifierGroup,
): ExtendedModifierGroup {
  const { modifications } = modifierGroup;

  const modificationWithIngredient = modifications.find(getModificationWithIngredient); // prettier-ignore
  const modificationIngredientKind = modificationWithIngredient?.ingredient?.kind; // prettier-ignore

  const checkIfHasSameKind = checkIfHasSameIngredientKindFactory(modificationIngredientKind); // prettier-ignore
  const hasSameIngredientKind = modifications.every(checkIfHasSameKind);

  return {
    ...modifierGroup,
    modificationIngredientKind: hasSameIngredientKind
      ? modificationIngredientKind
      : undefined,
  };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getModificationWithIngredient(modification: ProductModification) {
  return modification.ingredient;
}

function checkIfHasSameIngredientKindFactory(
  modificationIngredientKind: IngredientKind | null | undefined,
) {
  return (modification: ProductModification) =>
    modification.ingredient?.kind === modificationIngredientKind;
}
